export const customerActions = {
  CREATE_PAYMENT_NONCE: "CREATE_PAYMENT_NONCE",
};
